import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import site from "../../../config/site";
import { resolveImageUrl } from "../../../lib/storage";
import LazyImage from "../work/travelPageTemplate/LazyLoadImages";

export default function About() {
  const [portrait, setPortrait] = useState("");

  useEffect(() => {
    let alive = true;
    if (site.aboutImage) {
      resolveImageUrl(site.aboutImage).then((u) => alive && setPortrait(u));
    }
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="page">
      <Helmet>
        <title>photoLevs: About</title>
        <meta
          name="description"
          content="Joseph Levermore, born in Birmingham, United Kingdom, was brought up in a family passionate about art."
        />
        <meta property="og:title" content="photoLevs: About" />
      </Helmet>

      <h1 className="page-title">About photoLevs.</h1>

      <div className="about-grid">
        <div className="prose">
          {site.about.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        {portrait && (
          <LazyImage
            src={portrait}
            alt="Joseph Levermore"
            eager
          />
        )}
      </div>
    </div>
  );
}